export default class BaseUpdateRequest {
	updatedAt: Date;			
}